export default "__VITE_ASSET__DI_EeH79__"